/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PrincipalRemoteSessionBinding,
  PrincipalRemoteSessionBinding$inboundSchema,
} from "./principalremotesessionbinding.js";

export type ListBindingsResponseBody = {
  items: Array<PrincipalRemoteSessionBinding>;
};

/** @internal */
export const ListBindingsResponseBody$inboundSchema: z.ZodMiniType<
  ListBindingsResponseBody,
  unknown
> = z.object({
  items: z.array(PrincipalRemoteSessionBinding$inboundSchema),
});

export function listBindingsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListBindingsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListBindingsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListBindingsResponseBody' from JSON`,
  );
}
